import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class MoveVertical extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <polygon points="7.3,1.9 7.3,6.9 8.7,6.9 8.7,1.9 12.3,4 13,2.7 8.4,0 7.6,0 3,2.7 3.7,4   " />
          <polygon points="8.7,14.1 8.7,9.1 7.3,9.1 7.3,14 3.7,12 3,13.3 7.6,16 8.4,16 13,13.3 12.3,12   " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/MoveVertical.js